import { faLeanpub } from "@fortawesome/free-brands-svg-icons";
import {
  faChalkboardTeacher,
  faColumns,
  faCommentDots,
  faHome,
  faInfo,
  faList,
  faPaperclip,
  faShoppingBasket,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import Style from "./TopNavbar.module.css";
import { LinkContainer } from "react-router-bootstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getCourseListApi, getPageApi } from "../../Api/ClientServices";
const TopNavbar = () => {
  const [pageList, setPageList] = useState([]);
  const [courseList, setCourseList] = useState([]);
  useEffect(() => {
    getPageList();
  }, []);
  const getPageList = async () => {
    const data = await getPageApi("all");
    setPageList(data.pages);
  };

  useEffect(() => {
    getCourseList();
  }, []);
  const getCourseList = async () => {
    const data = await getCourseListApi();
    setCourseList(data.courses);
  };

  return (
    <>
      <Navbar
        collapseOnSelect
        expand="lg"
        bg="light"
        variant="light"
        className={Style.NavbarHolder}
      >
        <Container className={Style.NavbarContainer}>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse
            id="responsive-navbar-nav"
            className={Style.CollapseHolder}
          >
            <Nav className={`${Style.NavbarContainer}`}>
              <LinkContainer to={"/"}>
                <Nav.Link className={Style.navText}>
                  {" "}
                  <FontAwesomeIcon icon={faHome} /> خانه
                </Nav.Link>
              </LinkContainer>
              {/* <Nav.Link onClick={scrollToBottom} className={Style.navText}><FontAwesomeIcon icon={faChalkboardTeacher}/> دوره ها</Nav.Link> */}
              {/* <NavDropdown className={Style.navCourse} title={<p><FontAwesomeIcon icon={faChalkboardTeacher}/>دوره ها</p>} id="navbarScrollingDropdown">
                    {
                        courseList.map((item,index)=>{
                            return(

                                <LinkContainer className={Style.CourseDropDown} key={index} to={`/course/${item.id}`}><Nav.Link className={Style.navText}><FontAwesomeIcon icon={faPaperclip}/> {item.name} </Nav.Link></LinkContainer>
                            )
                        })
                    }
                </NavDropdown> */}
              <LinkContainer to={"/panel"}>
                <Nav.Link className={Style.navText}>
                  <FontAwesomeIcon icon={faColumns} /> پنل کاربری
                </Nav.Link>
              </LinkContainer>
              <LinkContainer to={"/guide"}>
                <Nav.Link className={Style.navText}>
                  <FontAwesomeIcon icon={faLeanpub} /> آموزش دسترسی{" "}
                </Nav.Link>
              </LinkContainer>
              <LinkContainer to={"/forum"}>
                <Nav.Link className={Style.navText}>
                  <FontAwesomeIcon icon={faCommentDots} /> انجمن{" "}
                </Nav.Link>
              </LinkContainer>
              <LinkContainer to={"/shop"}>
                <Nav.Link className={Style.navText}>
                  <FontAwesomeIcon icon={faShoppingBasket} /> سبدخرید{" "}
                </Nav.Link>
              </LinkContainer>

                <Nav.Link
                  className={Style.navText}
                  href="https://stepshop.ir/"
                  target="_blank"
                >
                  <FontAwesomeIcon icon={faShoppingBasket} /> فروشگاه الکترونیک{" "}
                </Nav.Link>

              {/* <LinkContainer to={'/about_us'}><Nav.Link className={Style.navText}><FontAwesomeIcon icon={faInfo}/> درباره ما </Nav.Link></LinkContainer> */}
              <NavDropdown
                className={Style.navText}
                title="صفحات مرتبط"
                id="navbarScrollingDropdown"
              >
                {pageList
                  .filter((value) => {
                    if (value.status === "1") {
                      return value;
                    }
                  })
                  .map((item, index) => {
                    return (
                      <LinkContainer key={index} to={`/${item.page}`}>
                        <Nav.Link className={Style.navText}>
                          <FontAwesomeIcon icon={faPaperclip} /> {item.title} 
                        </Nav.Link>
                      </LinkContainer>
                    );
                  })}
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
          <Navbar.Brand className={Style.navLogo}>
            <img
              className={Style.logoNavbar}
              src="/Assets/Images/Regular/Logo.png"
              alt="ElectronicSteps"
            />
            <div>
              <p>گام به گام با الکترونیک</p>
              <a href="tel:09111555313">09111555313</a>
            </div>
          </Navbar.Brand>
        </Container>
      </Navbar>
    </>
  );
};

export default TopNavbar;
